import styled from 'styled-components';
import colorpicker from 'assets/img/ColorWheel.png';
import textcolorpicker from 'assets/img/Editing-Text-Color-icon.png';
import { BASE_S3 } from 'config/consts';

export const Question = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 120px;
  height: auto;
  border-radius: 6px;
  padding: 20px 25px;
  background: ${props =>
    !props.image
      ? props.background
        ? props.background
        : '#2D95EF'
      : props.image.indexOf('base64') > -1
      ? `url(${props.image})`
      : `url(${BASE_S3}/${props.image})`};
  background-position: center;
  background-size: cover;

  p {
    color: ${props => props.textColor};
    text-align: center;
    font-size: 24px;
    margin: 0;
    line-height: 1.5;
    font-family: Roboto;
    width: 100%;
    height: fit-content;
    border: 0;
    resize: none;
    background: none;
    word-break: break-word;
  }
`;

export const TextImage = styled.div`
  color: ${props => props.textColor};
  width: 100%;
  min-height: 40px;
  height: auto;
  font-size: 20px;
  text-align: center;
  background: #f7f7f7;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-top: 1px;
  padding: 20px 25px;

  p {
    color: ${props => props.textColor};
    text-align: center;
    font-size: 24px;
    font-family: Roboto;
    line-height: 1.5;
    margin: 0;
    width: 100%;
    height: fit-content;
    border: 0;
    resize: none;
    background: none;
    word-break: break-word;
  }
`;

export const IconBackground = styled.div`
  position: absolute;
  bottom: 15px;
  right: 10px;

  label {
    cursor: pointer;
    margin: 0;

    &:hover {
      opacity: 0.7;
    }

    input {
      display: none;
    }
  }
`;

export const ColorPicker = styled.div`
  position: absolute;
  bottom: 52px;
  right: 12px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${`url(${colorpicker})`};
  background-position: center;
  background-size: cover;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const TextColorPicker = styled.div`
  position: absolute;
  bottom: 85px;
  right: 12px;
  width: 18px;
  height: 18px;
  background: ${`url(${textcolorpicker})`};
  background-position: center;
  background-size: cover;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;
